<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="红包类型">
                <el-select size="small" v-model="queryForm.packetType" placeholder="请选择" style="width: 200px">
                    <el-option v-for="item in packetTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="指定用户红包">
                <GridSelect
                    style="width: 180px"
                    title="选择用户"
                    labelName="userName"
                    labelValue="id"
                    :value="queryForm.userId"
                    :limit="1"
                    size="small"
                    placeholder="请选择用户"
                    @getValue="getValueSelset"
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl="/mpp/user/findList"
                    entityBeanName="mppUser"
                    queryEntityUrl="/mpp/user/get"
                >
                </GridSelect>
            </el-form-item>
            <el-form-item label="指定用户等级">
                <el-select size="small" v-model="queryForm.gradeId" placeholder="请选择" style="width: 200px">
                    <el-option v-for="role in mppGradeList" :key="role.id" :label="role.gradeName" :value="role.id"> </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopRedPacketList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopRedPacket">新建</el-button>
                    <!-- <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopRedPacket(null)"
                        >修改</el-button
                    > -->
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopRedPacket(null)"
                        >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopRedPacketList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="shopRedPacketList" height='100%' row-key="id" border @selection-change="handleSelectionChange" size="small">
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="id" label="红包编号" width="300"> </el-table-column> -->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="remarks" label="备注" width="110">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="totalAmount" label="红包总金额" width="110">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="totalPacket" label="红包总个数" width="110">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="" label="红包领取金额" width="110">
                    <template slot-scope="scope">
                        <div>
                            {{ (scope.row.totalAmount - scope.row.leftAmount).toFixed(2) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="" label="红包领取个数" width="110">
                    <template slot-scope="scope">
                        <div>
                            {{ (scope.row.totalPacket - scope.row.leftPacket) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="leftAmount" label="红包剩余金额" width="110">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.leftAmount.toFixed(2) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="leftPacket" label="红包剩余个数" width="110">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="packetType" label="红包类型" width="110">
                    <template slot-scope="scope">
                        <div>
                            {{ getPacketType(scope.row.packetType) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="目标用户" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            指定用户红包:{{ scope.row.user.userName }}
                        </div>
                        <div v-if="scope.row.grade">
                            指定用户等级:{{ scope.row.grade.gradeName }}
                        </div>
                        <div v-if="scope.row.post">
                            指定用户岗位:{{ scope.row.post.postName }}
                        </div>
                    </template>
                </el-table-column>
<!--                <el-table-column :show-overflow-tooltip="true" align="center" prop="gradeId" label="指定用户等级" width="110">-->
<!--                    <template slot-scope="scope">-->
<!--                        <div v-if="scope.row.grade">-->
<!--                            {{ scope.row.grade.gradeName }}-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column :show-overflow-tooltip="true" align="center" prop="postId" label="指定用户岗位" width="110">-->
<!--                    <template slot-scope="scope">-->
<!--                        <div v-if="scope.row.postId">-->
<!--                            {{ scope.row.postId }}-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="isRandom" label="是否随机" width="110">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.isRandom == 0 ? '否' : '是' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="giveOut" label="是否发放" width="110">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.giveOut == 0 ? '否' : '是' }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" width="180">
                </el-table-column>

                <el-table-column fixed="right" align="center" label="操作" width="260">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div v-if="scop.row.giveOut == 0" @click="provide(scop.row.id, scop.row.giveOut)">
                                <span class="operation-label">发放</span>
                            </div>
                            <div v-if="scop.row.giveOut == 1" @click="provide(scop.row.id, scop.row.giveOut)">
                                <span class="operation-label">取消发放</span>
                            </div>
                            <div @click="showRedPacketRecord(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">领取详情</span>
                            </div>
                            <div @click="checkShopRedPacket(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <!-- <div @click="editShopRedPacket(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div> -->
                            <div @click="deleteShopRedPacket(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="shopRedPacketStates[shopRedPacketState]" :visible.sync="showDialog" width="40%" @close="closeDialog">
                <div>
                    <el-form :model="shopRedPacket" ref="shopRedPacketForm" :rules="rules" label-width="120px" :inline="true" size="small">
                        <el-form-item label="红包类型" prop="packetType" style="width: 100%">
                            <el-select size="small" v-model="shopRedPacket.packetType" :disabled="shopRedPacketState == 'check'" placeholder="请选择" style="width: 180px">
                                <el-option v-for="item in packetTypeList" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
<!--                            <el-radio-group v-model="shopRedPacket.packetType" :disabled="shopRedPacketState == 'check'">-->
<!--                                <el-radio label="1">普通红包</el-radio>-->
<!--                                <el-radio label="2">等级红包</el-radio>-->
<!--                                <el-radio label="3">用户红包</el-radio>-->
<!--                                <el-radio label="4">岗位红包</el-radio>-->
<!--                            </el-radio-group>-->

                            <!-- <el-input size="small" v-model="shopRedPacket.packetType" :disabled="shopRedPacketState == 'check'"></el-input> -->
                        </el-form-item>
                        <el-form-item label="是否随机" prop="isRandom">
                            <el-select
                                size="small"
                                v-model="shopRedPacket.isRandom"
                                :disabled="shopRedPacketState == 'check'"
                                placeholder="请选择"
                                style="width: 180px"
                            >
                                <el-option label="否" value="0"> </el-option>
                                <el-option label="是" value="1"> </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="随机最小金额" prop="minAmount" v-if="shopRedPacket.isRandom == 1">
                            <el-input size="small" v-model="shopRedPacket.minAmount" :disabled="shopRedPacketState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="随机最大金额" prop="maxAmount" v-if="shopRedPacket.isRandom == 1">
                            <el-input size="small" v-model="shopRedPacket.maxAmount" :disabled="shopRedPacketState == 'check'"></el-input>
                        </el-form-item>

                        <el-form-item label="红包总金额" prop="totalAmount">
                            <el-input size="small" v-model="shopRedPacket.totalAmount" :disabled="shopRedPacketState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="红包总个数" prop="totalPacket">
                            <el-input size="small" v-model="shopRedPacket.totalPacket" :disabled="shopRedPacketState == 'check'"></el-input>
                        </el-form-item>
                        <!-- <el-form-item v-if="shopRedPacket.packetType != 3" label="红包剩余金额" prop="remainingAmount">
                            <el-input
                                size="small"
                                v-model="shopRedPacket.remainingAmount"
                                :disabled="shopRedPacketState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item v-if="shopRedPacket.packetType != 3" label="红包剩余个数" prop="remainingPacket">
                            <el-input
                                size="small"
                                v-model="shopRedPacket.remainingPacket"
                                :disabled="shopRedPacketState == 'check'"
                            ></el-input>
                        </el-form-item> -->
                        <el-form-item
                            v-if="shopRedPacket.packetType != 1 && shopRedPacket.packetType == 2"
                            label="指定用户等级"
                            prop="typeId"
                        >
                            <el-select
                                size="small"
                                v-model="shopRedPacket.typeId"
                                placeholder="请选择"
                                :disabled="shopRedPacketState == 'check'"
                                style="width: 180px"
                            >
                                <el-option v-for="role in mppGradeList" :key="role.id" :label="role.gradeName" :value="role.id">
                                </el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item
                            v-if="shopRedPacket.packetType == 4"
                            label="指定用户岗位"
                            prop="typeId"
                        >
                            <el-select
                                size="small"
                                v-model="shopRedPacket.typeId"
                                placeholder="请选择"
                                :disabled="shopRedPacketState == 'check'"
                                style="width: 180px"
                            >
                                <el-option v-for="role in postList" :key="role.id" :label="role.postName" :value="role.id">
                                </el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item
                            v-if="shopRedPacket.packetType != 1 && shopRedPacket.packetType == 3"
                            label="指定用户红包"
                            prop="typeId"
                        >
                            <GridSelect
                                style="width: 180px"
                                title="选择用户"
                                labelName="userName"
                                labelValue="id"
                                :value="shopRedPacket.typeId"
                                :limit="1"
                                size="small"
                                placeholder="请选择用户"
                                @getValue="getValue"
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl="/mpp/user/findList"
                                entityBeanName="mppUser"
                                queryEntityUrl="/mpp/user/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item label="红包备注：" prop="remarks">
                            <el-input style="width: 300px" type="textarea" v-model="shopRedPacket.remarks" :disabled="shopRedPacketState == 'check'"></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopRedPacketState != 'check'">确定</el-button>
                </div>
            </el-dialog>

<!--            <red-packet-details-->
<!--                @cancel="cancel"-->
<!--            ></red-packet-details>-->
            <el-drawer
                title="红包纪录"
                :visible.sync="redPacketVisible"
                direction="rtl"
                size="70%"
                :before-close="closeRedPacketRecord">
                <ShopRedPacketRecord :redPacketId="redPacketId" ref="shopRedPacketRecord"/>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import GridSelect from '@/components/gridselect';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ShopRedPacketRecord from './ShopRedPacketRecord.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
        ShopRedPacketRecord
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopRedPacketList();
                this.getShopRedPacketList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopRedPacketList();
                this.getShopRedPacketList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            redPacketId: '',
            redPacketVisible: false,
            queryForm: {
                packetType: '', //红包类型
                userId: '', //指定用户红包
                gradeId: '' //指定用户等级
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopRedPacketState: 'add',
            shopRedPacketStates: {
                add: '新建红包',
                check: '查看红包',
                edit: '修改红包'
            },

            multipleSelection: [],
            shopRedPacketList: [],
            postList:[],//获取的岗位信息
            shopRedPacket: {
                totalAmount: '', //红包总金额
                totalPacket: '', //红包总个数
                // remainingAmount: '', //红包剩余金额
                // remainingPacket: '', //红包剩余个数
                packetType: '', //红包类型 1 普通红包（所有用户都可以领取），2用户红包（指定用户） 3等级红包（指定等级用户）
                typeId: '', //所属类型id
                giveOut: 0,
                isRandom: '0',
                minAmount: '', //最小金额
                maxAmount: '', //最大金额
                remarks:''//红包备注
            },
            btnLoading: false,

            rules: {
                id: [{ required: true, message: '红包id不能为空', trigger: 'blur' }],
                totalAmount: [{ required: true, message: '红包总金额不能为空', trigger: 'blur' }],
                minAmount: [{ required: true, message: '随机最小金额不能为空', trigger: 'blur' }],
                maxAmount: [{ required: true, message: '随机最大金额不能为空', trigger: 'blur' }],
                totalPacket: [{ required: true, message: '红包总个数不能为空', trigger: 'blur' }],
                remainingAmount: [{ required: true, message: '红包剩余金额不能为空', trigger: 'blur' }],
                remainingPacket: [{ required: true, message: '红包剩余个数不能为空', trigger: 'blur' }],
                packetType: [{ required: true, message: '请选择红包类型', trigger: 'change' }],
                typeId: [{ required: true, message: '请指定目标', trigger: 'blur' }],
                createUserId: [{ required: true, message: '创建人不能为空', trigger: 'blur' }],
                udpateUserId: [{ required: true, message: '修改人不能为空', trigger: 'blur' }],
                createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
                updateTime: [{ required: true, message: '修改时间不能为空', trigger: 'blur' }],
                deleteFlag: [{ required: true, message: '是否删除 0 否，1 是不能为空', trigger: 'blur' }],
                isRandom: [{ required: true, message: '请选择是否随机', trigger: 'change' }],
                remarks: [{ required: true, message: '红包备注不能为空', trigger: 'change' }],
            },
            mppGradeList: [],
            packetTypeList: [],
        };
    },
    created() {
        this.getPacketTypeEnum();
        this.getShopRedPacketList();
        this.getMppGradeList();
        this.getPostList();
    },
    methods: {
        getPacketTypeEnum() {
            get('/mpp/utils/getEnum', { enumType: 'packet_type' }).then((res) => {
                if (res.success && res.code == 200) {
                    this.packetTypeList = res.enumList;
                }
            });
        },
        getPacketType(packetType) {
            for (const index in this.packetTypeList) {
                if (this.packetTypeList[index].key == packetType) {
                    return this.packetTypeList[index].value;
                }
            }
        },
        getValue(value) {
            console.log(value);
            this.shopRedPacket.typeId = value;
        },
        getValueSelset(value) {
            this.queryForm.typeId = value;
        },
        getMppGradeList() {
            get(`/mpp/grade/findList`, { pageNum: 1, pageSize: 100 }).then((res) => {
                if (res.success && res.code == 200) {
                    this.mppGradeList = res.page.list;
                }
            });
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopRedPacketList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopRedPacketList = [];
        },
        resetDialog() {
            this.shopRedPacketState = 'add';
            this.showDialog = false;
            this.queryForm = {
                packetType: '', //红包类型 1 普通红包（所有用户都可以领取），2用户红包（指定用户） 3等级红包（指定等级用户）
                userId: '', //指定用户红包
                gradeId: '' //指定用户等级
            };
            this.getShopRedPacketList();
        },
        closeDialog() {
            this.shopRedPacket = {
                totalAmount: '', //红包总金额
                totalPacket: '', //红包总个数
                // remainingAmount: '', //红包剩余金额
                // remainingPacket: '', //红包剩余个数
                packetType: '', //红包类型
                typeId: '', //所属类型id
                giveOut: 0,
                isRandom: '0',
                minAmount: '', //最小金额
                maxAmount: '' //最大金额
            };
            this.showDialog = false;
        },
        submitForm() {
            if (this.shopRedPacket.isRandom == '1') {
                let sum = this.shopRedPacket.totalAmount / this.shopRedPacket.totalPacket;
                if (this.shopRedPacket.minAmount > sum) {
                    this.$message.error('随机最小金额不能大于' + sum);
                    return;
                }
                if (this.shopRedPacket.maxAmount < sum) {
                    this.$message.error('随机最大金额不能小于' + sum);
                    return;
                }
            }
            if (this.shopRedPacket.packetType == '1') {
                this.shopRedPacket.userId = '';
                this.shopRedPacket.gradeId = '';
            }
            if (this.shopRedPacket.packetType == '2') {
                this.shopRedPacket.userId = '';
            }
            if (this.shopRedPacket.packetType == '3') {
                this.shopRedPacket.gradeId = '';
            }

            if (this.shopRedPacketState == 'add') {
                this.$refs.shopRedPacketForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/shopredpacket/add`, { ...this.shopRedPacket }).then((res) => {
                            console.log(this.shopRedPacket);

                            if (res.success && res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopRedPacketList();
                                this.resetDialog();
                                this.getShopRedPacketList();
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            } else if (this.shopRedPacketState == 'edit') {
                this.$refs.shopRedPacketForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/shopredpacket/edit`, { ...this.shopRedPacket }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopRedPacketList();
                                this.resetDialog();
                                // this.closeDialog();
                                this.getShopRedPacketList();
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }
                });
            }
        },
        addShopRedPacket() {
            this.showDialog = true;
            this.shopRedPacketState = 'add';
        },
        checkShopRedPacket(shopRedPacketId) {
            console.log(shopRedPacketId);
            this.currentShopRedPacketId = shopRedPacketId;

            this.getShopRedPacketById();
            this.showDialog = true;
            this.shopRedPacketState = 'check';
        },
        editShopRedPacket(shopRedPacketId) {
            console.log('shopRedPacket', shopRedPacketId);
            if (shopRedPacketId) {
                this.currentShopRedPacketId = shopRedPacketId;
                this.getShopRedPacketById();
            } else {
                this.shopRedPacket = { ...this.shopRedPacket, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopRedPacketState = 'edit';
        },
        deleteShopRedPacket(shopRedPacketId) {
            let ids = '';
            if (shopRedPacketId) {
                ids = shopRedPacketId;
            } else {
                ids = this.multipleSelection.map((shopRedPacket) => shopRedPacket.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/shopredpacket/delete`, { ids }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopRedPacketList();
                            this.getShopRedPacketList();
                        }
                    });
                })
                .catch(() => {});
        },
        // 发放
        provide(id, giveout) {
            let state = null;
            let stateText = '';
            console.log(typeof giveout);
            if (giveout == 0) {
                state = 1;
                stateText = '确定发放红包吗, 是否继续?';
            } else {
                state = 0;
                stateText = '确定取消发放红包吗, 是否继续?';
            }
            this.$confirm(stateText, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            })
                .then(() => {
                    post(`/shop/shopredpacket/giveout`, { giveOut: state, id: id }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopRedPacketList();
                            this.getShopRedPacketList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        // 领取详情
        refreshShopRedPacketList() {
            this.resetShopRedPacketList();
            this.getShopRedPacketList();
        },
        getShopRedPacketList(query = {}) {
            this.loading = true;
            get(`/shop/shopredpacket/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success && res.code == 200) {
                    this.shopRedPacketList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopRedPacketById() {
            get(`/shop/shopredpacket/get`, { id: this.currentShopRedPacketId }).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopRedPacket = { ...this.shopRedPacket, ...res.shopRedPacket };
                    // this.shopRedPacket.packetType = String(this.shopRedPacket.packetType);
                    this.shopRedPacket.isRandom = String(this.shopRedPacket.isRandom);
                }
            });
        },
        //获取用户岗位
        getPostList(){
          get('/mpp/post/findList',{pageNum:1,pageSize:50}).then((res)=>{
            if(res.success && res.code == 200){
                this.postList = res.page.list
                console.log(this.postList,8989);
            }
          })
        },

        /**
         * 导出信息
         */
        exportShopRedPacketList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/shopredpacket/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/shopredpacket/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/shopredpacket/importData`, formData);
            this.refreshShopRedPacketList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopRedPacketList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopRedPacketList();
        },
        showRedPacketRecord(id) {
            this.redPacketId = id
            this.redPacketVisible = true;
            this.$nextTick(()=>{
                this.$refs.shopRedPacketRecord.getShopRedPacketRecordList();
            })
        },
        closeRedPacketRecord() {
            this.redPacketVisible = false;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

// 让固定列的高自适应，且设置!important覆盖ele-ui的默认样式
// 20px 为滚动条的高度
// ::v-deep .el-table .el-table__fixed,
// ::v-deep .el-table .el-table__fixed-right {
//     height: calc(100% - 20px) !important;
// }
</style>
